import { useEffect, useState } from 'react';
import { navItems } from '@/mocks/home';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        scrolled ? 'bg-background-50/95 backdrop-blur border-b border-background-200' : 'bg-transparent'
      }`}
    >
      <nav className="w-full px-4 md:px-8">
        <div className="flex items-center justify-between h-16 md:h-[72px]">
          <a href="#top" className="flex items-center gap-3 cursor-pointer">
            <span className="w-10 h-10 flex items-center justify-center rounded-md bg-primary-500 text-background-50">
              <i className="ri-shield-cross-line text-xl"></i>
            </span>
            <span className="flex flex-col leading-none">
              <h1 className="font-heading text-lg md:text-xl font-bold tracking-wide text-foreground-950">缅北黑料</h1>
              <span className="text-[11px] md:text-xs text-foreground-500 tracking-[0.2em] mt-1">亲历者口述档案</span>
            </span>
          </a>

          <div className="hidden md:flex items-center gap-7">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                className="text-sm text-foreground-700 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                {item.label}
              </a>
            ))}
          </div>

          <div className="flex items-center gap-3">
            <a
              href="#cta"
              className="hidden sm:inline-flex items-center gap-2 h-10 px-5 rounded-md bg-accent-500 text-background-50 text-sm font-medium hover:bg-accent-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-download-2-line"></i>
              下载自查手册
            </a>
            <button
              type="button"
              aria-label="打开菜单"
              onClick={() => setMenuOpen((prev) => !prev)}
              className="md:hidden w-10 h-10 flex items-center justify-center rounded-md border border-background-300 text-foreground-800 cursor-pointer"
            >
              <i className={menuOpen ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'}></i>
            </button>
          </div>
        </div>

        {menuOpen && (
          <div className="md:hidden pb-4 pt-1 border-t border-background-200">
            <div className="flex flex-col py-2">
              {navItems.map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  onClick={() => setMenuOpen(false)}
                  className="py-2.5 text-sm text-foreground-700 hover:text-primary-600 transition-colors cursor-pointer"
                >
                  {item.label}
                </a>
              ))}
            </div>
            <a
              href="#cta"
              onClick={() => setMenuOpen(false)}
              className="inline-flex w-full items-center justify-center gap-2 h-10 rounded-md bg-accent-500 text-background-50 text-sm font-medium hover:bg-accent-600 transition-colors cursor-pointer"
            >
              <i className="ri-download-2-line"></i>
              下载自查手册
            </a>
          </div>
        )}
      </nav>
    </header>
  );
}